import {Marker as LeafletMarker} from "react-leaflet";
import {useContext, useMemo} from "react";
import {renderToStaticMarkup} from "react-dom/server";
import L from "leaflet";
import {MapContext} from "../context/MapContext";
import {markerIcons} from './markerIcons';
import {simulatedPosition} from "../data/current-location";

const toSoftColor = color => {
  const channels = color.slice(1).match(/.{2}/g).map(value => parseInt(value, 16))
  return `#${channels.map(channel => Math.round(channel * 0.14 + 255 * 0.86).toString(16).padStart(2, '0')).join('')}`
}

const Marker = ({item, element, animateOnLoad, isLeaving, popDelay}) => {
  const {featuredMarker, setFeaturedMarker, setMapFocus, setPanelStatus, setRouteTarget} = useContext(MapContext)
  const isFeaturedMarker = featuredMarker === element
  const isClosestFeaturedLocation = useMemo(() => {
    if (!isFeaturedMarker || element?.coords?.length < 2) return false

    const closestLocation = element.coords.reduce((closest, location) => (
      L.latLng(location).distanceTo(simulatedPosition) < L.latLng(closest).distanceTo(simulatedPosition)
        ? location
        : closest
    ))

    return closestLocation === item
  }, [element?.coords, isFeaturedMarker, item])
  const pinIcon = useMemo(() => {
    const color = /^#[0-9a-f]{6}$/i.test(element?.color) ? element.color : '#6D7280'
    const softColor = toSoftColor(color)
    const Icon = markerIcons[element?.name]
    const symbol = Icon ? renderToStaticMarkup(
      <Icon size={18} weight="Filled" color={color} className="marker-pin-symbol" aria-hidden="true" focusable="false" />
    ) : ''

    return L.divIcon({
      className: `marker${isFeaturedMarker ? ' featured-marker' : ''}${animateOnLoad ? ' marker-pop' : ''}${isLeaving ? ' marker-filter-out' : ''}`,
      iconSize: [36, 43],
      iconAnchor: [18, 42],
      tooltipAnchor: [0, -38],
      html: `<span class="marker-pin" style="--pop-delay: ${popDelay}ms"><svg class="marker-pin-shape" viewBox="0 0 44 52" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M22 1C10.4 1 1 10.4 1 22c0 12 10.5 21 21 29 10.5-8 21-17 21-29C43 10.4 33.6 1 22 1Z" fill="white"/><circle cx="22" cy="21" r="15.5" fill="${softColor}"/></svg>${symbol}${isClosestFeaturedLocation ? '<span class="marker-closest-tooltip">Más cercana</span>' : ''}</span>`,
    })
  }, [element?.color, element?.name, isFeaturedMarker, isClosestFeaturedLocation, animateOnLoad, isLeaving, popDelay])

  const selectMarker = () => {
    setFeaturedMarker(element)
    setMapFocus({coords: [item], id: `${element.type}-${element.index}-${Date.now()}`})
    setRouteTarget(item)
    setPanelStatus('close')
  }

  return (
    <LeafletMarker
      position={item}
      icon={pinIcon}
      title={element?.name}
      zIndexOffset={isFeaturedMarker ? 1000 : 0}
      eventHandlers={{
        click: () => selectMarker()
      }}
    >
    </LeafletMarker>
  )
}

export default Marker;
